import { api } from '../index';
import { objectToFormData } from '@/api/util';

const prefix = '/api/partner/';

// #3406 : 인자 없이 부르면 종전 요청 그대로다. Restriction Only 보기는 { restriction_only: 'true' } 로 지정 State 목록을 받는다.
export function apiIndex(params) {
	return params ? api.get(prefix + 'index', { params }) : api.get(prefix + 'index');
}

export function apiSelectPartnerList(param, config) {
	return api.post(prefix + 'selectPartnerList', param, config);
}

export function apiSelectSimplePartnerList(param) {
	return api.post(prefix + 'selectSimplePartnerList', param);
}

export function apiSelectPartner(param) {
	return api.post(prefix + 'selectPartner', param);
}

export function apiDetailIndex() {
	return api.get(prefix + 'detailIndex');
}

export function apiCheckPartnerExists(param) {
	return api.post(prefix + 'checkPartnerExists', param);
}

export function apiSelectNewPartnerCode() {
	return api.post(prefix + 'selectNewPartnerCode');
}

export function apiInsertPartner(param) {
	param.mode = 'insert';
	return apiSubmitPartner(param);
}

export function apiUpdatePartner(param) {
	param.mode = 'update';
	return apiSubmitPartner(param);
}

export function apiDeletePartner(param) {
	param.mode = 'delete';
	return apiSubmitPartner(param);
}

export function apiUpdatePart(param) {
	return api.post(prefix + 'updatePart', param);
}

export function apiUpdatePartnerBlock(param) {
	return api.post(prefix + 'updatePartnerBlock', param);
}

export function apiUpdatePartnerArMemo(param) {
	return api.post(prefix + 'updatePartnerArMemo', param);
}

export function apiUpdatePartnerSgMemo(param) {
	return api.post(prefix + 'updatePartnerSgMemo', param);
}

export function apiUpdateNotice(param) {
	return api.post(prefix + 'updateNotice', param);
}

export function apiUpdatePartnerSalesGroupBatch(param) {
	return api.post(prefix + 'updatePartnerSalesGroupBatch', param);
}

export function apiUpdatePartnerSalesmanBatch(param) {
	return api.post(prefix + 'updatePartnerSalesmanBatch', param);
}

export function apiUpdatePartnerSalesgroupAndSalesmanBatch(param) {
	return api.post(prefix + 'updatePartnerSalesgroupAndSalesmanBatch', param);
}

function apiSubmitPartner(param) {
	return api.post(prefix + 'submitPartner', param);
}

export function apiInsertPartnerDocInfo(param) {
	param.mode = 'insert';
	return apiSubmitPartnerDocInfo(param);
}

export function apiDeletePartnerDocInfo(param) {
	param.mode = 'delete';
	return apiSubmitPartnerDocInfo(param);
}

function apiSubmitPartnerDocInfo(param) {
	return api.post(prefix + 'submitPartnerDocInfo', param);
}

export function apiSelectMemoList(param) {
	return api.post(prefix + 'selectMemoList', param);
}

export function apiSelectPartnerAndMemos(partner_code) {
	return api.get(prefix + 'selectPartnerAndMemos', { params: { partner_code } });
}

export function apiSubmitMemo(param) {
	return api.post(prefix + 'submitMemo', param);
}

export function apiInsertEachMemo(param) {
	param.mode = 'insert';
	return apiSubmitEachMemo(param);
}

export function apiUpdateEachMemo(param) {
	param.mode = 'update';
	return apiSubmitEachMemo(param);
}

function apiSubmitEachMemo(param) {
	return api.post(prefix + 'submitEachMemo', param);
}

export function apiDeleteMemo(param) {
	return api.post(prefix + 'deleteMemo', param);
}

export function apiCustomersWithOutInvoices(param) {
	return api.get(prefix + 'customers-without-invoices', { params: param });
}

export function apiPartnerNotActive(param) {
	return api.put(prefix + 'partner-not-active', objectToFormData(param));
}

export function apiUpdateBillToOfPartners(bill_to, partner_codes) {
	return api.put(prefix + 'bill-to-batch', objectToFormData({ bill_to, partner_codes }));
}

export function apiConfirmAddress(address, city, state) {
	return api.get(prefix + 'confirmAddress', { params: { address, city, state } });
}

export function apiSelectPartnerBlockHistory(param) {
	return api.post(prefix + 'selectPartnerBlockHistory', param);
}

export function apiSelectPartnerActiveHistory(param) {
	return api.post(prefix + 'selectPartnerActiveHistory', param);
}
